(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3MemberLookupModal', {
            templateUrl: 'app/shared/modals/member-lookup-modal.component.html',
            controller: MemberLookupModalComponent,
            bindings: {
                close: '&',
                dismiss: '&',
                modalInstance: '<'
            }
        });

    var extend = angular.extend,
        isUndefined = angular.isUndefined;

    ///////////////////////////////////////////////////////
    // Outline
    ///////////////////////////////////////////////////////
    /*
        1. ΑΩ
            a. init
            b. destroy

        2. Interface
            a. search
            b. select
            c. submit

        3. Core
            d. keydown
            e. refresh
            f. seek

        4. Misc
            a. getPageCount
            b. scrollIntoView
            c. forceAutoFocus
    */

    var noop = angular.noop;

    MemberLookupModalComponent.$inject = ['$scope', '$element', '$timeout', '$q', 'Member', 'alert', 'keys', 'memberLookupPageSize', 'memberLookupDebounce', 'shared_resources'];
    function MemberLookupModalComponent($scope, $element, $timeout, $q, Member, alert, keys, memberLookupPageSize, memberLookupDebounce, resources) {
        // Variables
        var ctrl = this,
            resource,
            pendingPage,
            table,
            rowIndex = 0;

        // Properties
        ctrl.searchText = '';
        ctrl.loading = false;
        ctrl.placeholder = resources.memberLookupPlaceholder;
        ctrl.members = [];
        ctrl.page = 1;
        ctrl.rowIndex = 0;
        ctrl.pageSize = memberLookupPageSize;
        Object.defineProperty(ctrl, 'pageCount', { get: getPageCount });

        // Methods
        ctrl.$onInit = init;
        ctrl.search = search;
        ctrl.select = select;
        ctrl.submit = submit;

        ///////////////////////////////////////////////////////
        // ΑΩ
        ///////////////////////////////////////////////////////
        function init() {
            $element.on('keydown', keydown);
            table = $element[0].querySelector('table');
            $scope.$watch('$ctrl.rowIndex', scrollIntoView);
            $scope.$on('$destroy', destroy);
            ctrl.modalInstance.rendered.then(forceAutoFocus);
        }

        function destroy() {
            $element.off('keydown', keydown);
        }

        ///////////////////////////////////////////////////////
        // Interface
        ///////////////////////////////////////////////////////
        function search() {
            pendingPage = 1;
            refresh();
        }
        function select(index) {
            ctrl.rowIndex = index;
            submit();
        }
        function submit() {
            var member;
            if (ctrl.members.length) {
                member = ctrl.members[ctrl.rowIndex];
                ctrl.close({ $value: member });
            }
        }

        ///////////////////////////////////////////////////////
        // Core
        ///////////////////////////////////////////////////////
        function keydown(e) {
            pendingPage = pendingPage || ctrl.page;

            switch (e.which) {
                // Paging
                // case keys.PAGEUP: setPendingPage(pendingPage - 1); break
                // case keys.PAGEDOWN: setPendingPage(pendingPage + 1); break;
                // case keys.HOME: setPendingPage(1); break;
                // case keys.END: setPendingPage(ctrl.pageCount); break;

                // Navigation
                case keys.UP: setRowIndex(ctrl.rowIndex - 1); break;
                case keys.DOWN: setRowIndex(ctrl.rowIndex + 1); break;
            }

            function setPendingPage(page) {
                pendingPage = Math.max(1, Math.min(ctrl.pageCount, page));
                refresh();
                e.preventDefault();
            }

            function setRowIndex(index) {
                $scope.$apply(apply);
                e.preventDefault();
                function apply() {
                    ctrl.rowIndex = Math.max(0, Math.min(ctrl.members.length - 1, index));
                }
            }
        }
        function refresh() {
            var pending = resource && resource.$promise.$$state.status === 0,
                cancelling = refresh.cancellingRequest;

            $timeout.cancel(refresh.timout);
            if (cancelling)
                return;
            else if (pending)
                cancelThenDebounce();
            else
                debounce();

            ///////////////////////////////

            function debounce() {
                console.log('debounce');
                refresh.cancellingRequest = false;
                refresh.timout = $timeout(seek.bind(ctrl, pendingPage - 1, 'begin'), memberLookupDebounce);
            }

            function cancelThenDebounce() {
                console.log('cancel');
                refresh.cancellingRequest = true;
                resource.$cancelRequest();
                resource.$promise.finally(debounce);
            }
        }
        function seek(offset, origin) {
            var page = origin === 'begin' ? 1 : origin === 'end' ? ctrl.pageCount : ctrl.page,
                newPage = Math.max(page + offset, 1),
                pageSize = ctrl.pageSize,
                searchText = ctrl.searchText;

            ctrl.loading = true;
            resource = Member.search({ text: searchText, $skip: (newPage - 1) * pageSize, $top: pageSize });
            resource.$promise = resource.$promise.then(transform).then(success, noop).finally(final);

            function transform(data) {
                return extend(data.members, { totalCount: data.totalCount });
            }

            function success(members) {
                var pageCount = getPageCount(members.totalCount, pageSize),
                    isPastTheEnd = !members.length && pageCount;

                if (isPastTheEnd)
                    return seek(0, 'end');
                ctrl.members = members;
                ctrl.page = newPage;
                ctrl.rowIndex = 0;
                pendingPage = null;
                return members;
            }

            function final() {
                ctrl.loading = false;
            }
        }

        ///////////////////////////////////////////////////////
        // Misc
        ///////////////////////////////////////////////////////
        function getPageCount(totalCount, pageSize) {
            totalCount = isUndefined(totalCount) ? ctrl.members.totalCount : totalCount;
            pageSize = isUndefined(pageSize) ? ctrl.pageSize : pageSize;
            return Math.ceil(totalCount / pageSize);
        }
        function scrollIntoView(newValue, oldValue) {
            var scrollRect, rowRect, diff, padding = 3,
                row = table.rows[ctrl.rowIndex];

            if (row) {
                scrollRect = table.parentNode.getBoundingClientRect();
                rowRect = row.getBoundingClientRect();
                diff = (rowRect.bottom + padding) - scrollRect.bottom;
                if (diff > 0)
                    table.parentNode.scrollTop += diff;
                else {
                    diff = (rowRect.top - padding) - scrollRect.top;
                    if (diff < 0)
                        table.parentNode.scrollTop += diff;
                }
            }
        }

        function forceAutoFocus() {
            $timeout(focus, 100, false);
            function focus() {
                $element[0].querySelector('[autofocus]').focus();
            }
        }
    }
})();